import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    legendForm: {
        width: 18,
        height: 18,
        float: 'left',
        marginRight: 8,
    },
});

export const ScaleIcon = ({color}) => {
    const classes = useStyles();
    return (
        <i 
            className={classes.legendForm}
            style={{
                backgroundColor: color
            }}
        />
    )
}

ScaleIcon.propTypes = {
    color: PropTypes.string.isRequired,
};
